import { useMemo } from 'react';
import { content } from '../content/siteContent';
import { useLanguage } from '../context/LanguageContext';

export default function useSiteContent() {
  const { language, setLanguage } = useLanguage();

  const siteContent = useMemo(() => content[language] || content.tr, [language]);

  return {
    language,
    setLanguage,
    siteContent,
  };
}
